import { styled } from '@linaria/react';

export const DrawerOrModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;
